import { FC, PropsWithChildren } from 'react'
import { container, nav, main, aside } from './styles.css'
import { trueOrUndefined } from '@genie-fintech/ui/functions'
import { useIsMounted } from '@genie-fintech/ui/hooks'
import NavbarContent from './NavbarContent'
import MobileNavbarContent from './MobileNavbarContent'
import SidebarMenuItem from './SidebarMenuItem'
import Loading from '$components/Loading'

const PageLayout: FC<PropsWithChildren> = ({ children }) => {
  const isMounted = useIsMounted()

  if (!isMounted) return <Loading />

  return (
    <article className={container}>
      <nav className={nav} data-ready={trueOrUndefined(isMounted)}>
        <NavbarContent />

        <MobileNavbarContent />
      </nav>

      <aside className={aside} data-ready={trueOrUndefined(isMounted)}>
        <SidebarMenuItem />
      </aside>

      <main className={main}>{children}</main>
    </article>
  )
}

export default PageLayout
